import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getProvider } from './providers';

interface Oembed {
  title: string;
  author_name: string;
  author_url: string;
  type: string;
  height: number;
  width: number;
  version: string;
  provider_name: string;
  provider_url: string;
  thumbnail_height: number;
  thumbnail_width: number;
  thumbnail_url: string;
  html: string;
}

// @ts-ignore
const baseQuery: BaseQueryFn = async function baseQuery(args, api, meta) {
  if (!args || !args.url) {
    return Promise.resolve({ data: { html: '' } });
  }

  const actualQuery = fetchBaseQuery();

  return actualQuery(args, api, meta);
};

export const api = createApi({
  reducerPath: 'oembed',
  baseQuery,
  endpoints: ({ query }) => ({
    getOembed: query<string, string>({
      query: (url) => {
        const provider = getProvider(url);
        return { url: provider.url };
      },
      transformResponse: (value, meta, arg) => {
        const provider = getProvider(arg);
        return provider.htmlFixer((value as Oembed).html);
      },
      providesTags: ['oembed'],
    }),
  }),
  refetchOnMountOrArgChange: 900,
  keepUnusedDataFor: 600,
  tagTypes: ['oembed'],
});
